module.exports = __webpack_public_path__ + "static/media/JustActMailers_1.1 Arbitrators-01.897946a8.png";